import { segment } from '@actions/analytics';
import { sendReferralEvent } from '@api/fetchers/checkout';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useCheckoutEventProps from '@hooks/useCheckoutEventProps';
import useFirstRenderSkip from '@hooks/useFirstRenderSkip';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { REFER_LINK_CLICKED } from './constants/segment';

const useReferralTracking = () => {
  const router = useRouter();
  const {
    goalUID,
    referral_code,
    referrer_name,
    referrer_uid,
    referrer_goal_name,
    referrer_goal_uid,
    referral_type,
    referrer_code,
    utm_medium,
    utm_source,
    utm_campaign
  } = router.query;

  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const eventProps = useCheckoutEventProps(goalUID);

  useEffect(() => {
    if (referrer_uid) {
      const referrerData = {
        referrer_name,
        referrer_uid,
        referrer_goal_name,
        referrer_goal_uid,
        referral_type,
        referrer_code,
        utm_medium,
        utm_source,
        utm_campaign
      };
      if (isLoggedIn) {
        segment.track(REFER_LINK_CLICKED, {
          ...eventProps,
          ...referrerData,
          referrer_code: referral_code
        });
      }
      if (referrer_uid && referrer_goal_uid) {
        sessionStorage.setItem('referrer_info', JSON.stringify(referrerData));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, referrer_uid]);

  useFirstRenderSkip(() => {
    if (isLoggedIn && referral_code) sendReferralEvent(referral_code);
  }, [isLoggedIn, referral_code]);
};

export default useReferralTracking;
